// THIS SCRIPT IS GENERATED BY tools/make-legacy.ts. DO NOT EDIT!

export const inverseFoldMap: Map<number, number[]> = new Map([
	[0x39c, [0xb5, 0x3bc]],
	[0x1c4, [0x1c5, 0x1c6]],
	[0x1c7, [0x1c8, 0x1c9]],
	[0x1ca, [0x1cb, 0x1cc]],
	[0x1f1, [0x1f2, 0x1f3]],
	[0x399, [0x345, 0x3b9, 0x1fbe]],
	[0x392, [0x3b2, 0x3d0]],
	[0x395, [0x3b5, 0x3f5]],
	[0x398, [0x3b8, 0x3d1]],
	[0x39a, [0x3ba, 0x3f0]],
	[0x3a0, [0x3c0, 0x3d6]],
	[0x3a1, [0x3c1, 0x3f1]],
	[0x3a3, [0x3c2, 0x3c3]],
	[0x3a6, [0x3c6, 0x3d5]],
	[0x412, [0x432, 0x1c80]],
	[0x414, [0x434, 0x1c81]],
	[0x41e, [0x43e, 0x1c82]],
	[0x421, [0x441, 0x1c83]],
	[0x422, [0x442, 0x1c84, 0x1c85]],
	[0x42a, [0x44a, 0x1c86]],
	[0x462, [0x463, 0x1c87]],
	[0xa64a, [0x1c88, 0xa64b]],
	[0x1e60, [0x1e61, 0x1e9b]]
]);
